import { take, call, put, takeLatest } from 'redux-saga/effects';
import pageTypes from '../actions/report.actions';
import { storeReport, changeDataReport } from '../actions/report.actions';
import api from "../api/api";

export function* getReport() {
    yield takeLatest(pageTypes.GET_REPORT, takeLatestReport);
}

function* takeLatestReport({payload}) {
    let {data} = yield call(api.post, `/v1${payload.pageSelected}`, { pageId: payload.id, page: payload.page, rowsPerPage: payload.rowsPerPage, ...payload.filters });   
    yield put(storeReport(data.reportResponse.reports[0]));
}

export function* filterReport() {
    yield takeLatest(pageTypes.FILTER_REPORT, takeLatestReportData);
}

function* takeLatestReportData({payload}) {
    let {data} = yield call(api.post, `/v1${payload.pageSelected}`, { pageId: payload.id, page: payload.page, rowsPerPage: payload.rowsPerPage, ...payload.filters });    
    yield put(changeDataReport(data.reportResponse.reports[0]));
}